import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { ProceedingView, getProceedingOptions } from '@/module/Author/Proceeding';

export const Route = createFileRoute('/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
});

function RouteComponent() {
  const { proceedingId } = Route.useParams();
  const { data: proceeding } = useSuspenseQuery(getProceedingOptions(proceedingId));

  return <ProceedingView proceeding={proceeding} />;
}
